import { HttpClient } from "../HttpClient";
/**
 * * Get Transaction List
 */

export const GetTransactionList = async({PageNumber, RowsPerPage, StatusIds, EmploymentStatusGroupIds, DateStart, DateEnd, SearchField}) => {
  try {
    const { data } = await HttpClient.get('api/instawage/advances', {
      params: {
        PageNumber,
        RowsPerPage,
        StatusIds,
        EmploymentStatusGroupIds,
        DateStart,
        DateEnd,
        SearchField,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
